export const Tags = [
    {id: "react", title: "react"},
    {id: "node", title: "node"},
    {id: "express", title: "express"},
    {id: "mongodb", title: "mongodb"},
    {id: "javascript", title: "javascript"},
    {id: "html", title: "html"},
    {id: "css", title: "css"},
    {id: "python", title: "python"},
    {id: "sql", title: "sql"},
    {id: "java", title: "java"}
];